import { type SxProps, type Theme } from "@mui/material";

import type { AdminChatMessage, PlacementChannelMetadata } from "../types";
import { parseCustomMessage } from "../utils/parseCustomMessage";
import { ChatMessageCard } from "./ChatMessageCard";
import { useTu } from "@src/appV2/i18n/useTu";

interface PlacementApplicationInterviewCancelledProps {
  message: AdminChatMessage;
  channelMetadata?: PlacementChannelMetadata;
  sx?: SxProps<Theme>;
}

export function PlacementApplicationInterviewCancelled(
  props: PlacementApplicationInterviewCancelledProps
) {
  const { tu } = useTu("chat");
  const { message, channelMetadata, sx } = props;
  const displayMessage = parseCustomMessage(message.message);

  const workerName = channelMetadata?.hcpName ?? "Worker";

  return (
    <ChatMessageCard
      title={tu("Interview Cancelled")}
      subtitle={displayMessage || `${workerName}'s interview has been cancelled by the workplace.`}
      sx={sx}
    />
  );
}
